// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3BYG6","item":"PaymentsMobile_item__2GqKl","label":"PaymentsMobile_label__17Qh4","amount":"PaymentsMobile_amount__2s4XW"};